import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Flex, Heading, Icon } from 'core/components';
import SaveDeckButton from 'app/components/decks/SaveDeckButton';
import { AddPanelButton } from 'app/views/boards/AddPanelButton';

@observer
class DeckHeading extends Component {
  static defaultProps = {
    icon: undefined,
    title: '',
    description: undefined,
    tools: undefined,
    justifyContent: 'space-between',
    iconSize: 40
  };

  render() {
    const {
      canCustomize,
      children,
      board,
      icon,
      title,
      tools,
      iconSize,
      isUnsaved,
      onAddPanel,
      onReset,
      onSave,
      ...rest
    } = this.props;

    return (
      <Flex {...rest} borderBottom="thin">
        {title && (
          <Flex width="100%" alignItems="center">
            {icon && <Icon icon={icon} iconSize={iconSize} color="warning" mr={1} />}
            <Heading level={5} m={0} mr={2}>
              {title}
            </Heading>
            {canCustomize && (
              <Flex gap={1} justifyContent="flex-end" flex="auto">
                <AddPanelButton board={board} onAddPanel={onAddPanel} />
                {/* reverting draft boards with default panels is complicated */}
                {isUnsaved && !board.get('draft') && <Button muted text="Revert" onClick={onReset} />}
                {isUnsaved && <SaveDeckButton board={board} onSave={onSave} />}
              </Flex>
            )}
          </Flex>
        )}
        {tools}
        {children}
      </Flex>
    );
  }
}

export default DeckHeading;
